import React from "react";
import { Link, useNavigate } from "react-router-dom";
import crossarrow from "../assets/images/crossarrow.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import { default as stars } from "../assets/images/stars.svg";
import profileicon from "../assets/images/profileicon.svg";
import { commonservices, CountCharacter } from "../services/CommonServices";
import Nodata from "./common-component/Nodata";
import { renderRatingStars } from "./Marketplace";

const ViewSimillar = ({ similarMachineList, param }) => {
  const navigate = useNavigate();
  const fnMachineDetail = (machine_id, pagename) => {
    navigate(
      `/marketplace/marketplace-detail/${commonservices.bodyEncryption(String(machine_id))}/Marketplace`,
    );
    // window.location.reload();
  };
  return (
    <div className="similar-items">
      <h3>View Similar</h3>
      {similarMachineList?.length > 0 ? (
        <>
          <div className="all-market-place-main view-similar-market-place-main">
            {similarMachineList?.map((item_m, index_m) => (
              <div
                key={index_m}
                className="single-market-place-main new-single-market-place-main cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  fnMachineDetail(item_m?.machineid, param?.pagename);
                }}
              >
                <div className="single-market-place-img">
                  <img
                    src={
                      item_m?.machinelogourl !== "" &&
                      item_m?.machinelogourl !== null
                        ? item_m?.machinelogourl
                        : DemoLogo
                    }
                    alt="machine logo"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = DemoLogo;
                    }}
                  />
                </div>
                <div className="machine-card-right-content">
                  <h4 title={item_m?.machinename}>
                    {commonservices.truncateText(item_m?.machinename, 30)}
                  </h4>
                  <div className="rating-user-box">
                    <span className="blue-badge">
                      {item_m?.ratingcount || 0} user
                    </span>
                    {item_m?.avgrating > 0 ? (
                      <div className="market-place-content-ratings">
                        {renderRatingStars(item_m?.avgrating)}
                        <span>{item_m?.avgrating?.toFixed(1)}</span>
                      </div>
                    ) : (
                      <div className="market-place-content-ratings">
                        {renderRatingStars(0)}
                        <span>{0}</span>
                      </div>
                    )}
                  </div>
                  <p
                    className="description-text-limited"
                    title={commonservices.truncateText(
                      commonservices.stripHTML(item_m?.shortdescription),
                      CountCharacter?.MachineShortDetail,
                    )}
                  >
                    {item_m?.shortdescription
                      ? commonservices.stripHTML(item_m.shortdescription)
                      : ""}
                  </p>
                  <div className="developer-box">
                    <img src={profileicon} alt="profileicon" />
                    <Link
                      to="/marketplace/developer"
                      state={{
                        subscriberId: item_m?.subscriberid,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item_m?.subscribername}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
            {/* {similarMachineList?.map((item_m, index_m) => (
              <div
                key={index_m}
                className="single-market-place-main cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  fnMachineDetail(item_m?.machineid, param?.pagename);
                }}
              >
                <div className="d-flex align-items-center justify-content-between gap-1 sehedular-card-inner-size">
                  <div className="d-flex align-items-center gap-2 ">
                    <div className="single-market-place-img">
                      <img
                        src={
                          item_m?.machinelogourl !== "" &&
                            item_m?.machinelogourl !== null
                            ? item_m?.machinelogourl
                            : DemoLogo
                        }
                        alt="annualsummary"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = DemoLogo;
                        }}
                      />
                    </div>

                    <div className="market-place-content-title">
                      <h4 title={item_m?.machinename}>
                        {commonservices.truncateText(item_m?.machinename, 30)}
                      </h4>
                    </div>
                  </div>
                  <h3 className="report-price-single">
                    {item_m?.price > 0
                      ? `$ ${(item_m?.price).toFixed(2)}`
                      : "Free"}
                  </h3>
                </div>
                <div className="market-place-content">
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <div className="market-place-content-title ms-auto">
                        {item_m?.averagerating > 0 && (
                          <div className="market-place-content-ratings">
                            <img src={stars} alt="stars" />
                            <span>{item_m?.averagerating.toFixed(1)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                      <p className="mb-0"
                        dangerouslySetInnerHTML={{
                          __html: item_m?.shortdescription
                            ? commonservices.truncateText(
                              commonservices.stripHTML(item_m.shortdescription),
                              100
                            )
                            : "",
                        }}
                      />
                  </div>
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="developer-name">
                      <span className="developer">Developer</span>
                      <Link
                        to="/marketplace/developer"
                        state={{
                          subscriberId: item_m?.subscriberid,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {item_m?.subscribername}
                      </Link>
                    </div>
                    <Link className="crossarrow ms-auto">
                      <img src={crossarrow} alt="crossarrow" />
                    </Link>
                  </div>
                </div>
              </div>
            ))} */}
          </div>
        </>
      ) : (
        <Nodata />
      )}
    </div>
  );
};

export default ViewSimillar;
